import script from "./sw-item-editor-file.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor-file.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor-file.vue?vue&type=style&index=0&id=c73c367a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c73c367a"]])

export default __exports__